import { memo } from "react";
import Question from "../Question/Question";
const ProvinceAndCity = ({
  index,
  id,
  disabled,
  label,
  noNumber,
  description,
  onChange,
  field_type,
  onRemove,
  formContainer,
  duplicateQuestion,
  question_number,
}) => {
  return (
    <Question
      question_number={question_number}
      formContainer={formContainer}
      duplicateQuestion={duplicateQuestion}
      disabled={disabled}
      onChange={onChange}
      description={description}
      label={label}
      index={index}
      id={id}
      onRemove={onRemove}
      type={"شهر و استان"}
    ></Question>
  );
};
export default memo(ProvinceAndCity);
